import {connect} from 'react-redux';
import ColorPicker, {ColorPickerProps} from './ColorPicker';
import Action from '../../redux/Actions';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';

const mapStateToProps = (state: ReduxState, ownProps: ColorPickerContainerProps): Partial<ColorPickerProps> => {
   return {
      annotationColor: state.annotationColor || '',
      onColorChange: ownProps.onColorChange,
      themeName: state.themeName
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<ColorPickerProps> => {
   return {
      setAnnotationColor: color => {
         dispatch(Action.setAnnotationColor(color));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(ColorPicker);

interface ColorPickerContainerProps {
   onColorChange(color: string): void;
}